import React, { Component } from 'react'
import { inject, observer } from 'mobx-react'
import { PAYMENT_PROVIDERS } from "~/utilities/constants"
import PaymentFormContainer from './PaymentFormContainer'
import PaymentForm from '~/components/payment'

@inject(all => ({
  isMobile: all.store.ui.isMobile,
  payment: all.store.payment,
  allowSubmit: all.store.payment.allowSubmit,
  isPayFlow: all.store.parkingFlow.flow.isPayFlow,
  handleCheckout: all.store.parkingFlow.flow.handleCheckout,
  get3DSVerifyAmount: all.store.parkingFlow.flow.get3DSVerifyAmount
}))
@observer
class PaymentInfo extends Component {
  render() {
    const { isPayFlow, isMobile, allowSubmit, payment, handleCheckout, get3DSVerifyAmount, cardless } = this.props
    return (
      <PaymentFormContainer
        isMobile={isMobile}
        payment={payment}
        isLoading={payment.isLoading}
        allowSubmit={allowSubmit}
        paymentProcessor={payment.paymentProcessor}
        cardless={cardless}
      >
        <PaymentForm
          isTosRequired
          checkoutFunction={handleCheckout}
          use3DS={isPayFlow}
          get3DSVerifyAmount={get3DSVerifyAmount}
          paymentProcessor={payment.paymentProcessor}
          simple={payment.paymentProcessor === PAYMENT_PROVIDERS.cko}
        />
      </PaymentFormContainer>
    )
  }
}

export default PaymentInfo
